import { sendRequest } from "../sendRequest";

export const updateKyc = (kycProps) => {
  return sendRequest("put", `/influencer/kyc`, kycProps).then(
    (res) => res.data
  );
};
